import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import './marketplacedetails.css';
import Navigation from '../../components/navigation/Navigation';
import HeaderProfile from "../../components/HeaderProfile";
import SliderThumbs from "../../components/sliderThumbs/sliderThumbs";
import PortalAlert from '../../components/portalAlert/portalAlert';
import leftArrow from '../../assets/arrow_back.svg';
import { getMarketPlaceByIdEdit } from '../../api/marketPlace';
import { formatDate } from '../../helpers/formatterHelper'
import DynamicHTMLRenderer from '../../helpers/dynamicHTMLRenderer'
import { hideLoading, showLoading } from '../../store/loading-reducer';
export default function MarketPlaceDetail() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [marketPlace, setMarketPlace] = useState({});
    const { baseId } = useParams();
    const hasSliderThumbs = marketPlace?.media?.length > 0;

    useEffect(() => {
            if (baseId > 0) {
                dispatch(showLoading());
            getMarketPlaceByIdEdit(baseId).then((response) => {
                let marketPlaceResponse = response.data.data;
                    setMarketPlace(marketPlaceResponse);
            }).catch((error) => {
                    console.error("Error fetching marketplace:", error);
            }).finally(() => {
                    dispatch(hideLoading());
            });
            }
    }, [baseId]);


    return (
        <div className="directory-wrap news-wrap">
            <div className="drawer-menu-collapse-wrap"></div>
            <Navigation />
            <div className="events-page-wrap">
                <div className="page-inner events-inner">
                    <div className="profile-wrap-outer mobile-show">
                        <HeaderProfile />
                    </div>

                    <div className="events-content-scrollable-wrap">
                        <div className="inner-pages-alert">
                            <PortalAlert />
                        </div>
                        <div className="profile-wrap-outer">
                            <HeaderProfile />
                        </div>
                        <div className="events-header-wrap marketplace-header-wrap">
                            <div className="marketplace-column-wrap inline-tags back-tag-wrap">
                                <div className="arrow-header-inline" onClick={() => navigate('/marketplace')}>
                                    <img src={leftArrow} alt="left arrow" className="left-arrow" loading="lazy" />
                                    <span>Back to Marketplace</span>
                                </div>
                            </div>

                            <div className={`marketplace-sidebyside-wrap ${!hasSliderThumbs ? "no-slide" : ""}`}>
                                <div className="marketplace-slider-wrap">
                                    {hasSliderThumbs ? (
                                        <SliderThumbs marketPlace={marketPlace ?? []}
                                            mainSliderSettings={{
                                                arrows: true,
                                                infinite: true, // Enables looping
                                                dots: false,
                                            }}
                                            thumbSliderSettings={{
                                                slidesToShow: 5,
                                                slidesToScroll: 1,
                                                infinite: true, // Enables looping
                                                focusOnSelect: true,
                                                arrows: false,
                                                dots: false,
                                            }}
                                        />

                                    ) : null}
                                </div>
                                <div className="marketplace-detail-content">
                                    <div className="marketplace-detail-info-wrap">
                                        <div className="marketplace-detail-info-item">
                                            <span className="marketplace-pill-item">{marketPlace?.marketPlaceTypes?.name}</span>
                                            <span className="marketplace-date">{formatDate(marketPlace.publishDate, "MMM dd")}</span>
                                            <span className="marketplace-location">{marketPlace?.location}</span>
                                        </div>
                                        <div className="marketplace-detail-info-item">
                                            <span className="marketplace-value">  {marketPlace?.amountInfo}
                                                {marketPlace?.amountType &&
                                                    <span className="marketplace-value-desc amount-type">{marketPlace?.amountType}</span>
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    <div className="marketplace-detail-content-info">
                                        <p className="marketplace-detail-title">{marketPlace?.title}</p>
                                        <p className="marketplace-detail-author">{marketPlace?.author}</p>
                                        <div className="marketplace-detail-text">{marketPlace?.content && DynamicHTMLRenderer(marketPlace?.content)}</div>
                                    </div>
                                    <div className="marketplace-detail-content-contact-wrap">
                                        <p className="marketplace-detail-text"><b>Contact</b></p>
                                        <p className="marketplace-detail-text">{marketPlace?.waterMark}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}
